<template>
    <div class="noData">
        <template v-if="locationFail">
            <van-image
                class="fail-img"
                :src="require('@/assets/img/fail.png')"
            />
            <h5>无法获取位置信息</h5>
            <van-button round size="small" type="primary" @click="goAddress">
                手动定位
            </van-button>
        </template>
        <template v-else>
            <van-image :src="require('@/assets/img/noData.png')" />
            <div class="txt" v-html="noDataTxt"></div>
        </template>
    </div>
</template>
<script>
export default {
    name: "NoData",
    props: ["noDataTxt", "locationFail"],
    methods: {
        goAddress() {
            this.$router.push("/ele/address");
        },
    },
};
</script>
<style lang="scss" scoped>
.van-image {
    margin-top: 30%;
    width: 1.62rem;
    margin-bottom: 0.29rem;
}
.fail-img {
    width: 1.2rem;
}
div {
    text-align: center;
}
.txt {
    line-height: 0.24rem;
}
h5 {
    margin: -0.15rem 0 0.15rem 0;
    font-size: 14rem;
    color: $smart-color-info;
}
</style>
